import { LAYOUTS, POSITION, } from '@voltmoney/types';
import _ from 'lodash';
import { AccordionArrow, AccordionTypeTokens, BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, CardOrientation, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, ImageSizeTokens, LimitCardTypeTokens, SizeTypeTokens, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, TagTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, } from './types';
import { getMoreMfPortfolio, goBack, goHome, goKfin, goPortfolio, goToNext, needHelp, } from './action';
import { addCommasToNumber, allowDynamicLimitFromBE, ELIGIBLE_LIMIT, getAutoDebitDate, getBackgroundColor, isFromJupiter, isMorePortfolioRenderCheck, showSupportNumberForAllCustomer, showSupportNUmberForPartner, } from '../../../configs/utils';
import SharedPropsService from '../../../SharedPropsService';
import sharedPropsService from '../../../SharedPropsService';
import { getDesiredValue } from '../portfolio_readonly/actions';
import { api } from '../../../configs/api';
import { AssetRepositoryType, getAppHeader, isDarkModeTheme } from '../../../configs/config';
import { Platform } from 'react-native';
import AsyncStorage from "@react-native-async-storage/async-storage";
let availableCASX;
let isDarkMode = isDarkModeTheme();
export const template = async (activeIndexs, availableCreditAmount, availableCAS, stepResponseObject, shouldShowGetMorePortfolio, totalPortfolioAmount, updateAvailableCASMap, showLessLimit = false, camsAmount, KFintechAmount, term, interestRate, interestAmount, autoDebitDate, toBeSavedPortfolios, isFromJupiterPlatform, showLessLimitV2, isEnhancedLimit, limitAmount, enhanceLimit, allowDynamicLimitFromBEFlag, isEligible, isFromMFCentral) => {
    return {
        layout: {
            id: ROUTE.MF_PLEDGE_PORTFOLIO,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                {
                    id: "customHeader",
                    type: WIDGET.CUSTOM_HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                },
                !isEnhancedLimit ? { id: "trialSpace", type: WIDGET.SPACE } : {},
                isEnhancedLimit ? { id: "trialSpace1", type: WIDGET.SPACE } : {},
                isEnhancedLimit ? { id: "enhanceLimitCard", type: WIDGET.ENHANCE_LIMIT_CARD } : {},
                isEnhancedLimit ? { id: "trialSpace2", type: WIDGET.SPACE } : {},
                {
                    id: 'trial',
                    type: WIDGET.ACCORDION,
                },
            ],
        },
        datastore: {
            customHeader: {
                title: isEnhancedLimit ? "Eligible limit" : "Unlock credit limit",
                hideGoBack: isFromJupiterPlatform,
                needHelpAction: {
                    routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_unlockCreditLimt_needHelp' }
                },
                isDarkMode: isDarkMode ? true : false,
                goBackAction: {
                    routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                    type: ACTION.GO_HOME,
                    payload: { id: 'bt_unlockCreditLimt_goBack' }
                },
            },
            trialSpace: {
                size: SizeTypeTokens.SIZE18
            },
            trialSpace1: {
                size: SizeTypeTokens.XL
            },
            trialSpace2: {
                size: SizeTypeTokens.XL
            },
            trial: {
                // id : `acd_unlockCreditLimit_creditLimit${activeIndexs}`,
                activeIndex: activeIndexs,
                disableSecond: true,
                isDarkMode: isDarkMode ? true : false,
                data: [
                    {
                        id: 1,
                        header: {
                            widgetItems: [
                                {
                                    id: 'portfolioTitleStack',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                        body: {
                            widgetItems: [
                                { id: 'portfolioCard', type: WIDGET.CARD },
                            ],
                        },
                        qaId: 'acd_unlockCreditLimit_checkPortfolio',
                    },
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                {
                                    id: 'setCreditLimitStack',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                        body: {
                            widgetItems: [
                                { id: 'amountCard', type: WIDGET.LIMIT_CARD },
                                { id: 'amountSpaces', type: WIDGET.SPACE },
                                ...(!allowDynamicLimitFromBEFlag && showLessLimitV2
                                    ? [{
                                            id: 'showLessLimitCard',
                                            type: WIDGET.CARD,
                                        }]
                                    : []),
                                ...(allowDynamicLimitFromBEFlag
                                    ? [{
                                            id: 'showLessLimitCard',
                                            type: WIDGET.CARD,
                                        }]
                                    : []),
                                { id: 'amountSpaces', type: WIDGET.SPACE },
                                { id: 'amountcontinue', type: WIDGET.BUTTON },
                            ],
                        },
                        qaId: 'acd_unlockCreditLimit_setCreditLimit',
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            trial2Accordion: {
                activeIndex: activeIndexs,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'otherChargesStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                { id: 'interestOptions', type: WIDGET.STACK },
                            ],
                        },
                        qaId: 'acd_unlockCreditLimit_interest',
                    },
                    {
                        id: 3,
                        header: {
                            widgetItems: [
                                { id: 'benefitsStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                { id: 'promoStackRoot', type: WIDGET.STACK },
                            ],
                        },
                        qaId: 'acd_unlockCreditLimit_benefits',
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            processingStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'processingFeeText', type: WIDGET.TEXT },
                    { id: 'processingFeeValue', type: WIDGET.TEXT },
                ],
            },
            enhanceLimitCard: {
                limitAmount: limitAmount
            },
            processingFeeText: {
                label: 'Processing fee (excl. GST)',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
            },
            processingFeeValue: {
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 20,
            },
            worksTitle: {
                label: 'Benefits for you',
                fontFamily: FontFamilyTokens.Poppins,
                color: ColorTokens.Grey_Night,
                fontWeight: '600',
                fontSize: FontSizeTokens.MD,
                lineHeight: 24,
            },
            portfolioTitleStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                bgColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.Transparent,
                isDarkMode: isDarkMode ? true : false,
                padding: {
                    top: SizeTypeTokens.Size6,
                    bottom: SizeTypeTokens.Size6,
                },
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'portfolioTitle', type: WIDGET.TEXT },
                    { id: 'space19', type: WIDGET.SPACE },
                ],
            },
            setCreditLimitStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                padding: {
                    top: SizeTypeTokens.Size6,
                    bottom: SizeTypeTokens.Size6,
                },
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'creditTitle', type: WIDGET.TEXT },
                    { id: 'space19', type: WIDGET.SPACE },
                ],
            },
            benefitsStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                padding: {
                    top: SizeTypeTokens.Size6,
                    bottom: SizeTypeTokens.Size6,
                },
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'worksTitle', type: WIDGET.TEXT },
                    { id: 'space19', type: WIDGET.SPACE },
                ],
            },
            portfolioTitle: {
                label: isFromJupiterPlatform ? '1. Get portfolio value' : '1. Get portfolio',
                fontFamily: FontFamilyTokens.Poppins,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                fontWeight: '600',
                fontSize: FontSizeTokens.MD,
                lineHeight: 24,
            },
            creditTitle: {
                label: isFromJupiterPlatform ? '2. Get credit limit' : '2. Set credit limit',
                fontFamily: FontFamilyTokens.Poppins,
                color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Smoke,
                fontWeight: '600',
                fontSize: FontSizeTokens.MD,
                lineHeight: 24,
            },
            portfolioCard: {
                width: StackWidth.MATCH_PARENT,
                padding: {
                    left: SizeTypeTokens.MD,
                    right: SizeTypeTokens.MD,
                },
                body: {
                    widgetItems: [
                        { id: 'portfolioValue', type: WIDGET.STACK },
                        { id: 'portfolioSpaces', type: WIDGET.SPACE },
                        { id: 'sourceValue', type: WIDGET.STACK },
                        { id: 'sourceSpaces', type: WIDGET.SPACE },
                        { id: 'contentCard', type: WIDGET.LIMIT_CARD },
                        { id: 'cardSpaces', type: WIDGET.SPACE },
                        { id: 'continue', type: WIDGET.BUTTON },
                    ],
                },
            },
            portfolioValue: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                widgetItems: [
                    { id: 'space1', type: WIDGET.STACK },
                    { id: 'value1', type: WIDGET.TEXT },
                ],
            },
            space1: {
                type: StackType.row,
                width: StackWidth.CONTENT,
                widgetItems: [{ id: 'key1', type: WIDGET.TEXT }],
            },
            interestOptions: {
                width: StackWidth.MATCH_PARENT,
                type: StackType.column,
                padding: {
                    left: SizeTypeTokens.LG,
                    right: SizeTypeTokens.MD,
                },
                widgetItems: [
                    { id: 'processingAccordion', type: WIDGET.ACCORDION },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'interestAccordion', type: WIDGET.ACCORDION },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'autoPayAccordion', type: WIDGET.ACCORDION },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'withdrawalAccordion', type: WIDGET.ACCORDION },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'termAccordion', type: WIDGET.ACCORDION },
                    { id: 'divider', type: WIDGET.DIVIDER },
                    { id: 'foreClosureAccordion', type: WIDGET.ACCORDION },
                ],
            },
            divider: {
                size: DividerSizeTokens.SM,
                color: ColorTokens.Grey_Chalk,
            },
            pCardText: {
                label: 'One-time processing fee, no hidden charges',
                fontSize: FontSizeTokens.XS,
            },
            interestRateT1: {
                label: 'Interest charged only on usage',
                fontSize: FontSizeTokens.XS,
            },
            interestRateT2: {
                label: `Monthly interest of ₹${interestAmount} on withdrawal of ₹10,000`,
                fontSize: FontSizeTokens.XS,
            },
            interestAutoPayT1: {
                label: Platform.OS === 'web'
                    ? `Interest statement will be generated at the end of month`
                    : `Interest statement will be generated at the\nend of month`,
                fontSize: FontSizeTokens.XS,
            },
            interestAutoPayT2: {
                label: Platform.OS === 'web'
                    ? `Hassle-free auto repayment of interest on ${autoDebitDate}`
                    : `Hassle-free auto repayment of interest on\n${autoDebitDate}`,
                fontSize: FontSizeTokens.XS,
            },
            withdrawalT1: {
                label: 'Withdraw money as per your convenience',
                fontSize: FontSizeTokens.XS,
            },
            withdrawalT2: {
                label: 'Repay principal amount anytime during the month, no prepayment charges.',
                fontSize: FontSizeTokens.XS,
            },
            termT1: {
                label: 'Tenure of the credit line facility is 12 months',
                fontSize: FontSizeTokens.XS,
            },
            foreClosureT1: {
                label: 'Close your loan anytime without any additional \ncharges or hidden fee.',
                fontSize: FontSizeTokens.XS,
            },
            termText2: {
                label: 'Renewal can be done easily without repaying principal',
                fontSize: FontSizeTokens.XS,
            },
            termTextStack2: {
                // width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.row,
                flex: 1,
                alignItems: StackAlignItems.flexStart,
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'termText2', type: WIDGET.TEXT },
                ],
            },
            interestAccordion: {
                id: 'acd_unlockCreditLimit_interestRate',
                icon: IconTokens.DownArrow,
                rightIcon: AccordionArrow.LEFT,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'interestRateStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'interestRateAccordionStack',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            autoPayAccordion: {
                id: 'acd_unlockCreditLimit_autoPay',
                icon: IconTokens.DownArrow,
                rightIcon: AccordionArrow.LEFT,
                width: '85%',
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'autoPayStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'interestAutopayAccordionStack',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            withdrawalAccordion: {
                id: 'acd_unlockCreditLimit_withdraw',
                icon: IconTokens.DownArrow,
                rightIcon: AccordionArrow.LEFT,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'withdrawalStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'withdrawAccordionStack',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            termAccordion: {
                id: 'acd_unlockCreditLimit_term',
                icon: IconTokens.DownArrow,
                rightIcon: AccordionArrow.LEFT,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'termStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'termAccordionMainstack',
                                    type: WIDGET.STACK,
                                    padding: {
                                        bottom: -12,
                                    },
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            foreClosureAccordion: {
                id: 'acd_unlockCreditLimit_foreClosure',
                icon: IconTokens.DownArrow,
                rightIcon: AccordionArrow.LEFT,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'foreClosureStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'foreClosureAccordionStack',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            processingAccordion: {
                id: 'acd_unlockCreditLimit_processingFee',
                rightIcon: AccordionArrow.LEFT,
                data: [
                    {
                        id: 2,
                        header: {
                            widgetItems: [
                                { id: 'processingStack', type: WIDGET.STACK },
                            ],
                        },
                        body: {
                            widgetItems: [
                                {
                                    id: 'processingFeeDropDown',
                                    type: WIDGET.STACK,
                                },
                            ],
                        },
                    },
                ],
                type: AccordionTypeTokens.LIST,
            },
            withdrawalS1: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'withdrawalT1', type: WIDGET.TEXT },
                ],
            },
            withdrawalS2: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                padding: {
                    top: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'withdrawalT2', type: WIDGET.TEXT },
                ],
            },
            withdrawAccordionStack: {
                width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.row,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'withdrawalCard', type: WIDGET.STACK },
                    { id: 'spaceSizeXXL', type: WIDGET.SPACE },
                ],
            },
            withdrawalCard: {
                // width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.column,
                flex: 1,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                marginRight: 12,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                },
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                bgColor: ColorTokens.Yellow_10,
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'withdrawalS1', type: WIDGET.STACK },
                    { id: 'contactUsSpace', type: WIDGET.SPACE },
                    { id: 'withdrawalS2', type: WIDGET.STACK },
                    { id: 'space19', type: WIDGET.SPACE },
                ],
            },
            termAccordionStack: {
                height: StackHeight.CONTENT,
                type: StackType.column,
                flex: 1,
                borderRadius: 4,
                marginRight: 12,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                },
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                bgColor: ColorTokens.Yellow_10,
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'termCard', type: WIDGET.STACK },
                    { id: 'contactUsSpace', type: WIDGET.SPACE },
                    { id: "termTextStack2", type: WIDGET.STACK },
                    { id: 'space19', type: WIDGET.SPACE },
                ],
            },
            termCard: {
                // width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.row,
                flex: 1,
                alignItems: StackAlignItems.flexStart,
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'termT1', type: WIDGET.TEXT },
                ],
            },
            foreClosureAccordionStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                height: StackHeight.CONTENT,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'foreclosureCard', type: WIDGET.STACK },
                    { id: 'spaceSize6_2', type: WIDGET.SPACE },
                ],
            },
            foreclosureCard: {
                // width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                flex: 1,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                bgColor: ColorTokens.Yellow_10,
                padding: {
                    top: SizeTypeTokens.LG,
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'foreClosureT1', type: WIDGET.TEXT },
                ],
            },
            interestAutoPayCard: {
                // width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.column,
                flex: 1,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                marginRight: 12,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                },
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                bgColor: ColorTokens.Yellow_10,
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'interestAutoPayS1', type: WIDGET.STACK },
                    { id: 'contactUsSpace', type: WIDGET.SPACE },
                    { id: 'interestAutoPayS2', type: WIDGET.STACK },
                    { id: 'space19', type: WIDGET.SPACE },
                ],
            },
            interestRateS1: {
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                padding: {
                    top: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space1', type: WIDGET.SPACE },
                    { id: 'interestRateT1', type: WIDGET.TEXT },
                ],
            },
            interestRateS2: {
                width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                padding: {
                    top: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space1', type: WIDGET.SPACE },
                    { id: 'interestRateT2', type: WIDGET.TEXT },
                ],
            },
            interestRateAccordionStack: {
                width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.row,
                borderRadius: 4,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'interestRateCard', type: WIDGET.STACK },
                    { id: 'spaceSize6_3', type: WIDGET.SPACE },
                ],
            },
            interestAutopayAccordionStack: {
                width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.row,
                borderRadius: 4,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'interestAutoPayCard', type: WIDGET.STACK },
                    { id: 'spaceSize6_4', type: WIDGET.SPACE },
                ],
            },
            termAccordionMainstack: {
                width: StackWidth.FULL,
                height: StackHeight.CONTENT,
                type: StackType.row,
                borderRadius: 4,
                padding: {
                    bottom: SizeTypeTokens.LG,
                },
                widgetItems: [
                    { id: 'termAccordionStack', type: WIDGET.STACK },
                    { id: 'spaceSize6_4', type: WIDGET.SPACE },
                ],
            },
            interestRateCard: {
                height: StackHeight.CONTENT,
                type: StackType.column,
                flex: 1,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                marginRight: 12,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                },
                bgColor: ColorTokens.Yellow_10,
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'interestRateS1', type: WIDGET.STACK },
                    { id: 'contactUsSpace', type: WIDGET.SPACE },
                    { id: 'interestRateS2', type: WIDGET.STACK },
                    { id: 'space19', type: WIDGET.SPACE },
                ],
            },
            interestRateStack: {
                type: StackType.row,
                width: StackWidth.FULL,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'interestRateText', type: WIDGET.TEXT },
                    { id: 'interestRateValue', type: WIDGET.TEXT },
                ],
            },
            interestRateText: {
                label: 'Interest rate',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
            },
            interestRateValue: {
                label: `${interestRate}%`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 20,
            },
            autoPayStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                height: StackHeight.CONTENT,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'autoPayText', type: WIDGET.TEXT },
                    { id: 'autoPayValue', type: WIDGET.TEXT },
                ],
            },
            autoPayText: {
                label: 'Interest autopay',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
            },
            autoPayValue: {
                label: `${autoDebitDate}`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 20,
            },
            withdrawalStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'withdrawalText', type: WIDGET.TEXT },
                    { id: 'withdrawalType', type: WIDGET.TEXT },
                ],
            },
            withdrawalText: {
                label: 'Withdrawal & repayment',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
            },
            withdrawalType: {
                label: 'Flexi',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 20,
            },
            termStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'termText', type: WIDGET.TEXT },
                    { id: 'durationValue', type: WIDGET.TEXT },
                ],
            },
            foreClosureStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    right: SizeTypeTokens.XL,
                },
                widgetItems: [
                    { id: 'foreClosureText', type: WIDGET.TEXT },
                    { id: 'foreClosureType', type: WIDGET.TEXT },
                ],
            },
            foreClosureText: {
                label: 'Foreclosure',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
            },
            foreClosureType: {
                label: 'Free',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 16,
            },
            termText: {
                label: 'Tenure',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
            },
            space11: {
                size: SizeTypeTokens.MD,
            },
            portfolioSpaces: {
                size: SizeTypeTokens.XL,
            },
            key1: {
                label: 'Portfolio value',
                fontFamily: FontFamilyTokens.Inter,
                color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
            },
            value1: {
                label: `₹${addCommasToNumber(totalPortfolioAmount)}`,
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 18,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
                fontWeight: '500',
                fontSize: FontSizeTokens.XS,
            },
            availableValue: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                justifyContent: StackJustifyContent.spaceBetween,
                widgetItems: [
                    { id: 'space2', type: WIDGET.STACK },
                    { id: 'value2', type: WIDGET.TEXT },
                ],
            },
            space2: {
                type: StackType.row,
                width: StackWidth.CONTENT,
                // },
                widgetItems: [{ id: 'key2', type: WIDGET.TEXT }],
            },
            space22: {
                size: SizeTypeTokens.MD,
            },
            key2: {
                label: 'Available limit',
                fontFamily: FontFamilyTokens.Inter,
                color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
            },
            value2: {
                label: `₹${addCommasToNumber(availableCreditAmount)}`,
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 18,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
                fontWeight: '500',
                fontSize: FontSizeTokens.XS,
            },
            availableSpaces: {
                size: SizeTypeTokens.XXL,
            },
            sourceValue: {
                type: StackType.row,
                widgetItems: [{ id: 'key3', type: WIDGET.TEXT }],
            },
            sourceSpaces: {
                size: SizeTypeTokens.XS,
            },
            space19: {
                size: SizeTypeTokens.MD,
            },
            spaceSize6: {
                size: SizeTypeTokens.Size6,
            },
            key3: {
                label: 'SOURCE',
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Charcoal,
                fontWeight: '400',
                fontSize: FontSizeTokens.XXS,
                lineHeight: 16,
            },
            contentCards: {
                type: StackType.row,
                widgetItems: [
                    { id: 'contentSpace', type: WIDGET.SPACE },
                    { id: 'contentCard', type: WIDGET.LIMIT_CARD },
                ],
            },
            contentSpace: {
                size: SizeTypeTokens.MD,
            },
            contentCard: {
                isDarkMode: isDarkMode ? true : false,
                data: [
                    {
                        label: 'From KFintech',
                        limitAmount: KFintechAmount === 0
                            ? 'No portfolio fetched'
                            : `Value: ₹${addCommasToNumber(KFintechAmount)}`,
                        secondrylabel: 'From KFintech',
                        payload: AssetRepositoryType.KARVY,
                        fetchedAmount: 'Value: ₹20,00,000',
                        isSecondryAction: true,
                        isPrimaryAction: KFintechAmount !== 0,
                        refreshAction: {
                            type: ACTION.NAV_PORTFOLIO,
                            payload: {
                                value: null,
                                widgetID: 'contentCard',
                                assetRepository: AssetRepositoryType.KARVY,
                            },
                            routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                        },
                    },
                    {
                        label: 'From CAMS',
                        limitAmount: camsAmount === 0
                            ? 'No portfolio fetched'
                            : `Value: ₹${addCommasToNumber(camsAmount)}`,
                        secondrylabel: 'From KFintech',
                        payload: AssetRepositoryType.CAMS,
                        fetchedAmount: 'Value: ₹20,00,000',
                        isSecondryAction: true,
                        isPrimaryAction: camsAmount !== 0,
                        refreshAction: {
                            type: ACTION.NAV_PORTFOLIO,
                            payload: {
                                value: null,
                                widgetID: 'contentCard',
                            },
                            routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                        },
                    },
                ],
                // label: 'From CAMS',
                // limitAmount: KFintechAmount === 0 ? 'No portfolio fetched' : `Value: ₹ ${addCommasToNumber(KFintechAmount)}`,
                // secondrylabel: 'From KFintech',
                // fetchedAmount: KFintechAmount === 0 ? 'No portfolio fetched' : `Value: ₹ ${addCommasToNumber(KFintechAmount)}`,
                type: LimitCardTypeTokens.LIST,
                isView: false,
                // isPrimaryAction: camsAmount === 0 ? false : true,
                // isSecondryAction: KFintechAmount === 0 ? false: true,
                action: {
                    type: ACTION.GET_MORE_MF_PORTFOLIO,
                    payload: {
                        casList: stepResponseObject.availableCAS,
                        value: null,
                        widgetID: 'contentCard',
                    },
                    routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                },
                // refreshAction: {
                //     type: ACTION.NAV_PORTFOLIO,
                //     payload: <pagePayload>{
                //         value: null,
                //         widgetID: "contentCard",
                //     },
                //     routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                // }
            },
            portfolioSpace: {
                size: SizeTypeTokens.XL,
            },
            amountCard: {
                label: isEnhancedLimit ? 'Additional credit limit' : 'Available credit limit',
                limitAmount: `${addCommasToNumber(availableCreditAmount)}`,
                isDarkMode: isDarkMode ? true : false,
                secondarylabel: 'Fetched mutual funds',
                fetchedAmount: `${addCommasToNumber(totalPortfolioAmount)}`,
                isView: false,
                type: LimitCardTypeTokens.DEFAULT,
            },
            amountSpaces: {
                size: SizeTypeTokens.XL,
            },
            amountcontinue: {
                id: 'bt_unlockCreditLimit_continue',
                label: 'Continue to set credit limit',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '700',
                width: ButtonWidthTypeToken.FULL,
                type: showLessLimitV2
                    ? ButtonTypeTokens.LargeOutline
                    : ButtonTypeTokens.MediumFilled,
                labelColor: showLessLimitV2
                    ? ColorTokens.Grey_400
                    : ColorTokens.White,
                action: {
                    type: ACTION.PORTFOLIO,
                    routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                    payload: {},
                },
            },
            cardSpaces: {
                size: SizeTypeTokens.XL,
            },
            spaceSizeXXL: {
                size: SizeTypeTokens.XXL,
            },
            spaceSize6_1: {
                size: SizeTypeTokens.XXL,
            },
            spaceSize6_2: {
                size: SizeTypeTokens.XXL,
            },
            spaceSize6_3: {
                size: SizeTypeTokens.XXL,
            },
            spaceSize6_4: {
                size: SizeTypeTokens.XXL,
            },
            spaceSize6_5: {
                size: SizeTypeTokens.XXL,
            },
            spaceSize6_6: {
                size: SizeTypeTokens.XXL,
            },
            continue: {
                id: 'bt_unlockCreditLimt_continueToSetCreditLimit',
                label: isFromJupiterPlatform ? 'Calculate my credit limit' : 'Continue to check credit limit',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '700',
                width: ButtonWidthTypeToken.FULL,
                type: (camsAmount === 0 && KFintechAmount === 0) || showLessLimit
                    ? ButtonTypeTokens.LargeOutline
                    : ButtonTypeTokens.MediumFilled,
                labelColor: (camsAmount === 0 && KFintechAmount === 0) || showLessLimit
                    ? ColorTokens.Grey_400
                    : ColorTokens.White,
                action: {
                    type: ACTION.NAV_NEXT,
                    routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                    payload: {
                        activeIndex: 2,
                        toBeSavedPorfolios: toBeSavedPortfolios,
                        showLessLimit: showLessLimitV2
                    },
                },
            },
            creditSpace: {
                size: SizeTypeTokens.XL,
            },
            processingText: {
                label: 'Processing fee',
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 24,
            },
            processingValue: {
                label: `₹1000`,
                fontSize: FontSizeTokens.MD,
                marginRight: 8,
                color: ColorTokens.Grey_Charcoal,
            },
            processingFeeSpace: {
                size: SizeTypeTokens.MD,
            },
            space5: { size: SizeTypeTokens.LG },
            divider2: {
                size: DividerSizeTokens.SM,
                color: ColorTokens.Grey_Milk_1,
            },
            space6: { size: SizeTypeTokens.LG },
            autoPayTextStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: 'autoPayTextSpace', type: WIDGET.SPACE },
                    { id: 'autoPayText', type: WIDGET.TEXT },
                    { id: 'autoPayTextSpace1', type: WIDGET.SPACE },
                    // { id: "autoPayIcon", type: WIDGET.ICON },
                ],
            },
            autoPayTextSpace: {
                size: SizeTypeTokens.MD,
            },
            autoPayTextSpace1: {
                size: SizeTypeTokens.XS,
            },
            processingCard: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                flex: 1,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR1,
                },
                bgColor: ColorTokens.Yellow_10,
                padding: {
                    top: SizeTypeTokens.SM,
                    bottom: SizeTypeTokens.SM,
                    right: SizeTypeTokens.XXXXXL,
                },
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardText', type: WIDGET.TEXT },
                ],
            },
            interestAutoPayS1: {
                // width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                padding: {
                    top: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'interestAutoPayT1', type: WIDGET.TEXT },
                ],
            },
            pCardIcon: {
                name: IconTokens.CoveredRightArrow,
                size: IconSizeTokens.SM,
                align: IconAlignmentTokens.center,
                color: ColorTokens.Grey_Charcoal,
            },
            interestAutoPayS2: {
                // width: StackWidth.MATCH_PARENT,
                height: StackHeight.CONTENT,
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                borderRadius: 4,
                padding: {
                    top: SizeTypeTokens.SM,
                },
                widgetItems: [
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'pCardIcon', type: WIDGET.ICON },
                    { id: 'space19', type: WIDGET.SPACE },
                    { id: 'interestAutoPayT2', type: WIDGET.TEXT },
                ],
            },
            processingGSTText: {
                label: 'GST @18%',
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 24,
            },
            processingGSTValue: {
                label: `₹180`,
                fontSize: FontSizeTokens.MD,
                marginRight: 8,
                color: ColorTokens.Grey_Charcoal,
            },
            divider4: {
                size: DividerSizeTokens.SM,
                color: ColorTokens.Grey_Milk_1,
            },
            divider5: {
                size: DividerSizeTokens.SM,
                color: ColorTokens.Grey_Milk_1,
            },
            space10: { size: SizeTypeTokens.LG },
            durationStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                widgetItems: [
                    //{ id: "durationText", type: WIDGET.TEXT },
                    { id: 'durationTextStack', type: WIDGET.STACK },
                    { id: 'durationValue', type: WIDGET.TEXT },
                ],
            },
            durationTextStack: {
                width: StackWidth.FULL,
                type: StackType.row,
                widgetItems: [
                    { id: 'durationTextSpace', type: WIDGET.SPACE },
                    { id: 'durationText', type: WIDGET.TEXT },
                ],
            },
            durationTextSpace: {
                size: SizeTypeTokens.MD,
            },
            durationText: {
                label: 'Duration',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Night,
            },
            durationValue: {
                label: `12 months (with renewal)`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
                marginRight: 20,
            },
            durationSpaces: {
                size: SizeTypeTokens.XL,
            },
            durationcontinue: {
                label: 'Got it',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '700',
                width: ButtonWidthTypeToken.FULL,
                type: ButtonTypeTokens.LargeOutline,
                labelColor: ColorTokens.Primary_100,
                action: {
                    routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                },
            },
            interestSpace: {
                size: SizeTypeTokens.XL,
            },
            workSpace: {
                size: SizeTypeTokens.XL,
            },
            showLessLimitCard: {
                hide: true,
                bgColor: ColorTokens.Red_10,
                width: StackWidth.FULL,
                padding: {
                    top: SizeTypeTokens.LG,
                    bottom: SizeTypeTokens.LG,
                    left: SizeTypeTokens.LG,
                    right: SizeTypeTokens.LG,
                },
                borderRadius: BorderRadiusTokens.BR2,
                bodyOrientation: CardOrientation.HORIZONTAL,
                body: {
                    widgetItems: [
                        { id: 'stackCardInfo', type: WIDGET.STACK }
                    ]
                }
            },
            stackCardInfo: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: 'stackCardInfoLeft', type: WIDGET.STACK },
                    { id: 'stackCardInfoRight', type: WIDGET.STACK },
                ]
            },
            stackCardInfoLeft: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                maxWidth: 30,
                widgetItems: [
                    { id: 'infoIcon', type: WIDGET.ICON },
                    { id: 'infoIconSpace', type: WIDGET.SPACE }
                ]
            },
            stackCardInfoRight: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                flex: 1,
                widgetItems: [
                    { id: 'infoLabel', type: WIDGET.TEXT },
                ]
            },
            infoIcon: {
                name: IconTokens.InfoFilled,
                color: ColorTokens.Red_50,
            },
            infoIconSpace: { size: SizeTypeTokens.Size10 },
            continueSpace: { size: SizeTypeTokens.LG },
            infoLabel: {
                label: `Minimum amount required to proceed is ${isEnhancedLimit ? `₹${addCommasToNumber(enhanceLimit)}` : `₹25,000`}`,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontColor: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.XS,
                lineHeight: 18,
            },
            card: {
                bgColor: ColorTokens.White,
                body: { widgetItems: [{ id: 'header', type: WIDGET.STACK }] },
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
            },
            //   header: <StackProps>{
            //     width: StackWidth.FULL,
            //     type: StackType.row,
            //     alignItems: StackAlignItems.center,
            //     justifyContent: StackJustifyContent.spaceBetween,
            //     padding: { horizontal: SizeTypeTokens.LG },
            //     widgetItems: [
            //       { id: "title", type: WIDGET.TEXT },
            //       { id: "headerRight", type: WIDGET.STACK },
            //     ],
            //   },
            headerRight: {
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.flexEnd,
                padding: { horizontal: SizeTypeTokens.LG },
                widgetItems: [{ id: 'contactUs', type: WIDGET.TAG }],
            },
            contactUs: {
                icon: {
                    align: IconAlignmentTokens.left,
                    name: IconTokens.FAQ,
                    size: IconSizeTokens.XL,
                },
                label: 'Need help?',
                labelColor: ColorTokens.Primary_100,
                type: TagTypeTokens.DEFAULT,
                bgColor: ColorTokens.Primary_05,
                action: {
                    type: ACTION.NAV_TO_CONTACT_US,
                    routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                    payload: {},
                },
            },
            contactUsSpace: { size: SizeTypeTokens.SM },
            title: {
                label: 'Unlock limit',
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '700',
            },
            // Mspace0: <SpaceProps>{ size: SizeTypeTokens.XL },
            creditLimitCard: {
                bgColor: ColorTokens.White,
                body: { widgetItems: [{ id: 'body', type: WIDGET.STACK }] },
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
            },
            body: {
                width: StackWidth.FULL,
                type: StackType.column,
                widgetItems: [
                    { id: 'creditLimit', type: WIDGET.TEXT },
                    { id: 'space111', type: WIDGET.SPACE },
                    { id: 'limitCard', type: WIDGET.LIMIT_CARD },
                    shouldShowGetMorePortfolio
                        ? { id: 'otherSourceStack', type: WIDGET.STACK }
                        : { id: 'skip', type: WIDGET.SPACE },
                    { id: 'space222', type: WIDGET.SPACE },
                    { id: 'lendingStack', type: WIDGET.STACK },
                ],
            },
            promoStackRoot: {
                type: StackType.column,
                width: StackWidth.FULL,
                widgetItems: [
                    { id: 'promoStack', type: WIDGET.STACK },
                    { id: 'promoSpace', type: WIDGET.SPACE },
                    { id: 'promoStack2', type: WIDGET.STACK },
                    { id: 'promoSpace2', type: WIDGET.SPACE },
                    { id: 'promoStack3', type: WIDGET.STACK },
                    { id: 'promoSpace3', type: WIDGET.SPACE },
                ],
            },
            promoStack: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.center,
                widgetItems: [
                    { id: 'image', type: WIDGET.IMAGE },
                    { id: 'imgSpace', type: WIDGET.SPACE },
                    { id: 'content', type: WIDGET.STACK },
                ],
            },
            promoStack2: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.center,
                widgetItems: [
                    { id: 'image2', type: WIDGET.IMAGE },
                    { id: 'imgSpace2', type: WIDGET.SPACE },
                    { id: 'content2', type: WIDGET.STACK },
                ],
            },
            promoStack3: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.center,
                widgetItems: [
                    { id: 'image3', type: WIDGET.IMAGE },
                    { id: 'imgSpace3', type: WIDGET.SPACE },
                    { id: 'content3', type: WIDGET.STACK },
                ],
            },
            promoStack4: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.center,
                widgetItems: [
                    { id: 'image4', type: WIDGET.IMAGE },
                    { id: 'imgSpace4', type: WIDGET.SPACE },
                    { id: 'content4', type: WIDGET.STACK },
                ],
            },
            promoSpace: {
                size: SizeTypeTokens.XXL,
            },
            promoSpace2: {
                size: SizeTypeTokens.XXL,
            },
            promoSpace3: {
                size: SizeTypeTokens.XXL,
            },
            image4: {
                uri: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOuSURBVHgBlVVdiBtVFP7uzcxssm6SadaudjWS+AObrSIt9cm/rlWXotIHoaCgFMQXfVlfKtpWC32oCtLYUvAH7GMriIqwyrKW1rrUF6Gt7o+0uJvuuu1uaJppOplkfm/vhM1kEia72Q9C7rn3nO8799yTE4I1wCbHH3BC9Hd3bcAYimR25rAO0LUcTLAE/0q5HwnSmcrMrymsA6sKHBmZk7/8bmDrciFSWNlKaWr32N73pt8aGbmQqvuxy6dfs6dPz9kzv33VykGCiLP7rj4VouQQX2537XSyjJ1PX/POv/65F7PXJchRe/SD1/OMAS97GTvkUbL5uam6LbSSH/tofh8cHPKLKyWxyefFbWVcmnUw/ITyEvPtM8Ms21X1Eb6cCrzB0QPzJ/jGnlbR+/o07Hp+EavB0bQaGw1HYNns1a7HXvih6QbH9i98zHPYExSckA2sBdrd3TBERLz9Wub75x8CYQfbBd9/r4aOwF+DVTSF3i6/rf8znvEEKCXfrha3aWMVncDRdZ69KNOenmcFge5194SjBxa3MGY/ExggUiTCOsJddif8vP5h1G/iGMZyTYAxZxdpbVZuF9NRFB+Oo7eyiHXBceCUVZCu8PvW9Hg/DRG21X9uxiUsPHkPCgMyHIHgYqwfN51w5wKUgkZjIJLEl6E0dRjbVLtViMB4PA79lT44CakhyChOaoNYLwgjEzojb1BenoQjS6gM93GBGM+AIBZtdv7PknFOT3ZEbFoEZy9Gl8jkje2RzFBO0LdtmDQHow/6ncQQ0MPbWvV151g1jc3iDfTSSlvyhbyI78/KWCoK/+7I7q51BjUz0bkgZ1dA9E2IChNwSssEEusmxeifcRz/8W4sFwXeIyRXP6Pc+gltEO9ptv2l0qohXMtHcHXxLpwcTeKPvxu/ZErYWH0txP7HX6UkFDDIrQJCm1KxWRNTFxoPVTYtb807PPfpkcFTnti7Q0QlFj5EGwSVauJWv2e70/SW0ZhVhJBv/PHeT+zwFXYGK/O/FRZ/roLCnQ2GxBUFck71zhQ+HkqG6WX/WXYw7Y/1/tGkKt7k6eSCBNxSbVB1JCeWmshLPHM/OX/QodbYpiFxeIalEMIvfNdrFzdr6ZICcUZtCizpBpSV0nDiy5xo+JNsJreqQEPIPshb4Z1Q3tjYdf4mqNp4RNNhKFarqNq1Nlf4gP7CgpHNZrcoQVyBAi4+P15IikulHbynd9uMDFQsO62ZJie28jzsPI88ZzL9RDviOu4A5zhsmkEc0QAAAAAASUVORK5CYII=',
                borderRadius: BorderRadiusTokens.BR5,
                size: ImageSizeTokens.XS,
            },
            imgSpace4: {
                size: SizeTypeTokens.XXL,
            },
            content4: {
                type: StackType.column,
                widgetItems: [],
            },
            titlePromo4: {
                label: 'No foreclosure charges',
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
            },
            titleSpace4: {
                size: SizeTypeTokens.SM,
            },
            subTitlePromo4: {
                label: 'Pay interest only on the borrow amount',
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                numberOfLines: 2,
            },
            image2: {
                uri: 'data:image/png;base64,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',
                borderRadius: BorderRadiusTokens.BR5,
                size: ImageSizeTokens.XS,
            },
            imgSpace2: {
                size: SizeTypeTokens.XXL,
            },
            content2: {
                type: StackType.column,
                widgetItems: [
                    { id: 'titlePromo2', type: WIDGET.TEXT },
                    { id: 'titleSpace2', type: WIDGET.SPACE },
                    { id: 'subTitlePromo2', type: WIDGET.TEXT },
                ],
            },
            titlePromo2: {
                label: 'No usage, no interest',
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
            },
            titleSpace2: {
                size: SizeTypeTokens.SM,
            },
            subTitlePromo2: {
                label: 'Pay interest only on the borrowed amount',
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                numberOfLines: 2,
            },
            image3: {
                uri: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOuSURBVHgBlVVdiBtVFP7uzcxssm6SadaudjWS+AObrSIt9cm/rlWXotIHoaCgFMQXfVlfKtpWC32oCtLYUvAH7GMriIqwyrKW1rrUF6Gt7o+0uJvuuu1uaJppOplkfm/vhM1kEia72Q9C7rn3nO8799yTE4I1wCbHH3BC9Hd3bcAYimR25rAO0LUcTLAE/0q5HwnSmcrMrymsA6sKHBmZk7/8bmDrciFSWNlKaWr32N73pt8aGbmQqvuxy6dfs6dPz9kzv33VykGCiLP7rj4VouQQX2537XSyjJ1PX/POv/65F7PXJchRe/SD1/OMAS97GTvkUbL5uam6LbSSH/tofh8cHPKLKyWxyefFbWVcmnUw/ITyEvPtM8Ms21X1Eb6cCrzB0QPzJ/jGnlbR+/o07Hp+EavB0bQaGw1HYNns1a7HXvih6QbH9i98zHPYExSckA2sBdrd3TBERLz9Wub75x8CYQfbBd9/r4aOwF+DVTSF3i6/rf8znvEEKCXfrha3aWMVncDRdZ69KNOenmcFge5194SjBxa3MGY/ExggUiTCOsJddif8vP5h1G/iGMZyTYAxZxdpbVZuF9NRFB+Oo7eyiHXBceCUVZCu8PvW9Hg/DRG21X9uxiUsPHkPCgMyHIHgYqwfN51w5wKUgkZjIJLEl6E0dRjbVLtViMB4PA79lT44CakhyChOaoNYLwgjEzojb1BenoQjS6gM93GBGM+AIBZtdv7PknFOT3ZEbFoEZy9Gl8jkje2RzFBO0LdtmDQHow/6ncQQ0MPbWvV151g1jc3iDfTSSlvyhbyI78/KWCoK/+7I7q51BjUz0bkgZ1dA9E2IChNwSssEEusmxeifcRz/8W4sFwXeIyRXP6Pc+gltEO9ptv2l0qohXMtHcHXxLpwcTeKPvxu/ZErYWH0txP7HX6UkFDDIrQJCm1KxWRNTFxoPVTYtb807PPfpkcFTnti7Q0QlFj5EGwSVauJWv2e70/SW0ZhVhJBv/PHeT+zwFXYGK/O/FRZ/roLCnQ2GxBUFck71zhQ+HkqG6WX/WXYw7Y/1/tGkKt7k6eSCBNxSbVB1JCeWmshLPHM/OX/QodbYpiFxeIalEMIvfNdrFzdr6ZICcUZtCizpBpSV0nDiy5xo+JNsJreqQEPIPshb4Z1Q3tjYdf4mqNp4RNNhKFarqNq1Nlf4gP7CgpHNZrcoQVyBAi4+P15IikulHbynd9uMDFQsO62ZJie28jzsPI88ZzL9RDviOu4A5zhsmkEc0QAAAAAASUVORK5CYII=',
                borderRadius: BorderRadiusTokens.BR5,
                size: ImageSizeTokens.XS,
            },
            imgSpace3: {
                size: SizeTypeTokens.XXL,
            },
            content3: {
                type: StackType.column,
                widgetItems: [
                    { id: 'titlePromo3', type: WIDGET.TEXT },
                    { id: 'titleSpace3', type: WIDGET.SPACE },
                    { id: 'subTitlePromo3', type: WIDGET.TEXT },
                ],
            },
            titlePromo3: {
                label: 'Repay anytime',
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
            },
            titleSpace3: {
                size: SizeTypeTokens.SM,
            },
            subTitlePromo3: {
                label: 'Pay as low as interest amount as EMI,\nrepay principal any time',
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                numberOfLines: 2,
            },
            image: {
                uri: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOuSURBVHgBlVVdiBtVFP7uzcxssm6SadaudjWS+AObrSIt9cm/rlWXotIHoaCgFMQXfVlfKtpWC32oCtLYUvAH7GMriIqwyrKW1rrUF6Gt7o+0uJvuuu1uaJppOplkfm/vhM1kEia72Q9C7rn3nO8799yTE4I1wCbHH3BC9Hd3bcAYimR25rAO0LUcTLAE/0q5HwnSmcrMrymsA6sKHBmZk7/8bmDrciFSWNlKaWr32N73pt8aGbmQqvuxy6dfs6dPz9kzv33VykGCiLP7rj4VouQQX2537XSyjJ1PX/POv/65F7PXJchRe/SD1/OMAS97GTvkUbL5uam6LbSSH/tofh8cHPKLKyWxyefFbWVcmnUw/ITyEvPtM8Ms21X1Eb6cCrzB0QPzJ/jGnlbR+/o07Hp+EavB0bQaGw1HYNns1a7HXvih6QbH9i98zHPYExSckA2sBdrd3TBERLz9Wub75x8CYQfbBd9/r4aOwF+DVTSF3i6/rf8znvEEKCXfrha3aWMVncDRdZ69KNOenmcFge5194SjBxa3MGY/ExggUiTCOsJddif8vP5h1G/iGMZyTYAxZxdpbVZuF9NRFB+Oo7eyiHXBceCUVZCu8PvW9Hg/DRG21X9uxiUsPHkPCgMyHIHgYqwfN51w5wKUgkZjIJLEl6E0dRjbVLtViMB4PA79lT44CakhyChOaoNYLwgjEzojb1BenoQjS6gM93GBGM+AIBZtdv7PknFOT3ZEbFoEZy9Gl8jkje2RzFBO0LdtmDQHow/6ncQQ0MPbWvV151g1jc3iDfTSSlvyhbyI78/KWCoK/+7I7q51BjUz0bkgZ1dA9E2IChNwSssEEusmxeifcRz/8W4sFwXeIyRXP6Pc+gltEO9ptv2l0qohXMtHcHXxLpwcTeKPvxu/ZErYWH0txP7HX6UkFDDIrQJCm1KxWRNTFxoPVTYtb807PPfpkcFTnti7Q0QlFj5EGwSVauJWv2e70/SW0ZhVhJBv/PHeT+zwFXYGK/O/FRZ/roLCnQ2GxBUFck71zhQ+HkqG6WX/WXYw7Y/1/tGkKt7k6eSCBNxSbVB1JCeWmshLPHM/OX/QodbYpiFxeIalEMIvfNdrFzdr6ZICcUZtCizpBpSV0nDiy5xo+JNsJreqQEPIPshb4Z1Q3tjYdf4mqNp4RNNhKFarqNq1Nlf4gP7CgpHNZrcoQVyBAi4+P15IikulHbynd9uMDFQsO62ZJie28jzsPI88ZzL9RDviOu4A5zhsmkEc0QAAAAAASUVORK5CYII=',
                borderRadius: BorderRadiusTokens.BR5,
                size: ImageSizeTokens.XS,
            },
            imgSpace: {
                size: SizeTypeTokens.XXL,
            },
            content: {
                type: StackType.column,
                widgetItems: [
                    { id: 'titlePromo', type: WIDGET.TEXT },
                    { id: 'titleSpace', type: WIDGET.SPACE },
                    { id: 'subTitlePromo', type: WIDGET.TEXT },
                ],
            },
            titlePromo: {
                label: 'Instant money transfer',
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night,
                fontWeight: '600',
                fontSize: FontSizeTokens.SM,
            },
            titleSpace: {
                size: SizeTypeTokens.SM,
            },
            subTitlePromo: {
                label: 'Get money instantly when you need it',
                fontFamily: FontFamilyTokens.Inter,
                color: ColorTokens.Grey_Night,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
                numberOfLines: 2,
            },
        },
    };
};
export const setCreditLimitMf2 = {
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NAV_PORTFOLIO]: goKfin,
        [ACTION.PORTFOLIO]: goPortfolio,
        [ACTION.GET_MORE_MF_PORTFOLIO]: getMoreMfPortfolio,
        [ACTION.NAV_NEXT]: goToNext,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.GO_HOME]: goHome,
    },
    bgColor: `#${getBackgroundColor()}`,
    clearPrevious: true,
    onLoad: async ({ instrumentTrack, showPopup, network, goBack }, { activeIndex, setShowSupportPhoneNumber, isFromMFCentral }) => {
        instrumentTrack("UNLOCK_CREDIT_LIMIT_PAGE_VIEWED", { "referrer": "getPortfolioSuccess" });
        const allowDynamicLimitFromBEFlag = await allowDynamicLimitFromBE();
        let activeIndexs;
        if (activeIndex === null ||
            activeIndex === 0 ||
            activeIndex === undefined ||
            activeIndex === '') {
            activeIndexs = 1;
        }
        else {
            activeIndexs = activeIndex;
        }
        let enhanceLimit = 25000;
        const updateAvailableCASMap = {};
        const authCAS = await SharedPropsService.getAuthCASResponse();
        let applicationId = "";
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = (await SharedPropsService.getUser())
                .linkedApplications[0].applicationId;
        }
        const pledgeLimitResponse = authCAS
            ? { data: authCAS }
            : {
                data: await network
                    .get(`${api.pledgeLimit}${applicationId}`, { headers: await getAppHeader() })
                    .then(response => {
                    return response.data;
                }),
            };
        /*** update authCAS in SharedPropsService if fetched from api ***/
        if (!authCAS && pledgeLimitResponse.data) {
            await SharedPropsService.setAuthCASResponse(pledgeLimitResponse.data);
        }
        const availableCreditAmount = pledgeLimitResponse.data.stepResponseObject.availableCreditAmount ||
            0;
        const totalPortfolioAmount = pledgeLimitResponse.data.stepResponseObject.totalPortfolioAmount ||
            0;
        const showSupportNumber = await showSupportNumberForAllCustomer();
        const showSupportNUmberForPartnerCustomer = await showSupportNUmberForPartner();
        if (availableCreditAmount >= ELIGIBLE_LIMIT.MIN_LIMIT || totalPortfolioAmount >= ELIGIBLE_LIMIT.MAX_AMOUNT || showSupportNumber) {
            if (Platform.OS === 'web') {
                setShowSupportPhoneNumber(true);
            }
            await SharedPropsService.setSupportPhoneNumber(true);
        }
        else {
            if (Platform.OS === 'web') {
                setShowSupportPhoneNumber(showSupportNUmberForPartnerCustomer);
            }
            await SharedPropsService.setSupportPhoneNumber(showSupportNUmberForPartnerCustomer);
        }
        const availableCAS = pledgeLimitResponse.data.stepResponseObject.availableCAS || [];
        await SharedPropsService.setCasListOriginal(availableCAS);
        const stepResponseObject = pledgeLimitResponse.data.stepResponseObject;
        //
        stepResponseObject.availableCAS.map((item, index) => {
            const key = `${item.isinNo}-${item.folioNo}`;
            item.pledgedUnits = item.totalAvailableUnits;
            updateAvailableCASMap[key] = item;
        });
        await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
        //
        /*** Show popup as soon as we land here if MF_PLEDGE_PORTFOLIO is PENDING_CALLBACK ***/
        const isGetMorePortfolio = await isMorePortfolioRenderCheck();
        const mfPortfolioArray = stepResponseObject.availableCAS;
        mfPortfolioArray.forEach((_item, index) => {
            mfPortfolioArray[index].is_pledged = _item.pledgedUnits > 0;
        });
        const pledgeData = await network.get(`${api.pledgeLimit}${applicationId}`, {
            headers: await getAppHeader(),
        });
        const interestRate = _.get(pledgeData, 'data.stepResponseObject.interestRate');
        const term = _.get(pledgeData, 'data.stepResponseObject.loanTenureInMonths');
        const pledgeDetails = await network.get(`${api.pledgeData}${applicationId}`, {
            headers: await getAppHeader()
        });
        const limitAmount = pledgeDetails?.data?.stepResponseObject?.existingSanctionedLimit;
        const toBeSavedPortfolios = mfPortfolioArray;
        await sharedPropsService.setCreditLimit(availableCreditAmount);
        const portValue = getDesiredValue(stepResponseObject['availableCAS'], stepResponseObject['isinNAVMap']);
        await sharedPropsService.setDesiredPortfolio(portValue);
        let showLessLimit;
        let showLessLimitV2;
        showLessLimit = false;
        const isEnhancedLimit = await AsyncStorage.getItem("application_id") !== null;
        if (isEnhancedLimit) {
            availableCreditAmount < enhanceLimit
                ? (showLessLimitV2 = true)
                : (showLessLimitV2 = false);
        }
        else {
            availableCreditAmount < 25000
                ? (showLessLimitV2 = true)
                : (showLessLimitV2 = false);
        }
        const minimumEligibleLimit = await SharedPropsService.getMinimumEligibleLimitData();
        //@ts-ignore
        const minimumAmount = minimumEligibleLimit?.amount;
        //@ts-ignore
        const isEligible = minimumEligibleLimit?.isEligible;
        if (allowDynamicLimitFromBEFlag) {
            if (!isEligible) {
                showLessLimitV2 = true;
            }
            else {
                showLessLimitV2 = false;
            }
        }
        const isFromJupiterPlatform = await isFromJupiter();
        console.warn("IS", isFromJupiterPlatform);
        let camsAmount = 0;
        let KFintechAmount = 0;
        camsAmount =
            pledgeLimitResponse.data.stepResponseObject
                .repositoryAssetMetadataMap.CAMS.availablePortfolioAmount || 0;
        KFintechAmount =
            pledgeLimitResponse.data.stepResponseObject
                .repositoryAssetMetadataMap.KARVY.availablePortfolioAmount || 0;
        const autoDebitDate = await getAutoDebitDate(network);
        const interestAmount = Math.floor((10000 * interestRate) / 1200);
        return Promise.resolve(template(activeIndexs, availableCreditAmount, availableCASX, stepResponseObject, isGetMorePortfolio, totalPortfolioAmount, updateAvailableCASMap, showLessLimit, camsAmount, KFintechAmount, term, interestRate, interestAmount, autoDebitDate, toBeSavedPortfolios, isFromJupiterPlatform, showLessLimitV2, isEnhancedLimit, limitAmount, enhanceLimit, allowDynamicLimitFromBEFlag, isEligible, isFromMFCentral));
    },
};
